import React from "react";
import {useNavigate} from "react-router-dom";

import SupportNewRequest from "../new-request";
import SupportPageLayout from "../../support-page-layout";

const SupportNewRequestPage = () => {

  const navigate = useNavigate();

  return (
    <SupportPageLayout
      isCreatingRequest
      onBackToSupport={() => navigate('/cabinet/support')}
    >
      <SupportNewRequest onCancel={() => navigate('/cabinet/support')} />
    </SupportPageLayout>
  );
};

export default SupportNewRequestPage;
